import './style.css';
import { beginBoot, markGameStarted, reportStartupError, showSafeMode, stageBeacon } from './core/crashGuard';
import { isIOS } from './core/quality';

async function boot(): Promise<void> {
  if (import.meta.env.DEV && new URLSearchParams(location.search).get('gamepad') === '1') {
    (await import('../../tools/gamepad-mock')).installGamepadMock();
  }
  if (beginBoot()) { showSafeMode(); return; }
  (window as any).__ready = false;
  let token: string | null = null;
  try { token = localStorage.getItem('nyc.token'); } catch { /* disabled storage */ }
  const params = new URLSearchParams(location.search);
  let registration: Awaited<ReturnType<typeof import('./ui/mobileEntry').waitForMobileEntry>> | ReturnType<typeof import('./ui/mobileEntry').waitForMobileEntry> | undefined;
  // Keep this import lazy so screenshot mode retains its original module ordering.
  if (isIOS() || (!params.has('spot') && !params.has('fly') && !token)) {
    const entry = (await import('./ui/mobileEntry')).waitForMobileEntry(!!token);
    if (params.get('det') !== '1') void import('./core/startupCache').then(cache => cache.beginStartupPrefetch());
    // iOS: registration must be usable before shader compilation, workers or world loading.
    // Elsewhere the renderer, physics and the detailed spawn scene are built behind the
    // opaque entry screen while the player types; main awaits the registration itself.
    registration = isIOS() ? await entry : entry;
  }
  // A time-portal traveller arriving (index.html marked it): the intertitle goes up before anything else loads.
  if (document.documentElement.classList.contains('era-arriving')) await import('./core/eraTravel').catch(() => undefined);
  markGameStarted();
  const canvas = document.createElement('canvas');
  canvas.id = 'game'; canvas.tabIndex = 0;
  document.body.prepend(canvas);
  stageBeacon('game_import');
  if (isIOS()) (await import('./core/textureRelease')).installTextureRelease();
  const { main } = await import('./main');
  await main(registration);
}
void boot().catch(error => { reportStartupError('fatal', error); showSafeMode(); });
